// extracted by mini-css-extract-plugin
module.exports = {"hamburger-button":"hamburger-button__8tQ20","sticky":"sticky__2xY_u","open":"open__DJaar","dark":"dark__2Z1cW","white":"white__3Ju5Z"};